<template>
  <section id="xsale">
    <div class="container">
      <div id="product-list">
        <ul class='products'>
          <li v-bind:key="product_index" v-for="(product,product_index) in products"
              v-bind:class="{'matched': true, 'kind-f': product.gender == 'F', 'kind-m': product.gender == 'M', 'kind-k': product.gender == 'K', 'kind-u': product.gender == 'U'}">
            <item :product="product"/>
          </li>
        </ul><!-- product -->
      </div>
    </div>
  </section>
</template>

<script>
  import Item from './Item'

  export default {
    name: 'crossseling',
    props: {
      productId: String
    },
    components: {Item},
    data () {
      return {
        products: []
      }
    },
    created () {
      let that = this

      $.getJSON(env.baseUrl + '/data/xsale/' + this.productId + '/xsale.json', function (data) {
        for (let i = 0; i < data.length; i++) {
          // jeśli mamy rower o takim product id
          if (env.data.bikes[data[i]['assigned_product_id']] != null) {
            that.products.push(env.data.bikes[data[i]['assigned_product_id']])
          }
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Products/Crossseling.vue